import * as React from "react";
import { PageProps } from "gatsby";
import Layout from "../../components/layout";
import Container from "../../components/ui-library/container/container";
import { AskAboutQuery_IntentCategory } from "../../../graphql-types";
import PageContainer from "../../components/ui-library/page-container/page-container";
import PageHeading from "../../components/ui-library/page-heading/page-heading";
import SEO from "../../components/seo/seo";
import { LogoBunny } from "../../components/site/header/header";
import Row from "../../components/ui-library/column-system/row";
import Column from "../../components/ui-library/column-system/column";
import { EventCategory } from "../../utils/analytics";
import WorldSnapshot from "../../components/covid-19/covid-intent/intent-specific-answers/daily-case-by-country/world-snapshot";
import Section from "../../components/ui-library/section/section";
import QuestionLink from "../../components/ui-library/question-link/question-link";
import Navigation from "../../components/site/navigation/navigation";
import { TOP_NAV_ITEM } from "../../constants/top-navigations";
import { Topic } from "../../types/topics";
import { getCOVIDIntentUrl } from "../../utils/question-url";

interface CategoryData {
  category: AskAboutQuery_IntentCategory;
  intents: {
    alias: string;
    displayName: string;
  }[];
}

type Covid19CategoryPageProps = PageProps<null, CategoryData>;

const Covid19CategoryPage: React.FC<Covid19CategoryPageProps> = ({
  pageContext: { category, intents },
}) => {
  return (
    <Layout
      topic={Topic.COVID19}
      description="coronavirus"
      headerUrl="/covid-19/"
      logoBunny={LogoBunny.FaceMask}
    >
      <SEO
        title={category.name}
        description={`COVID-19 topic: ${category.name}`}
        imageUrl={`/media/images/social-share/covid-19/category-${category.alias}.jpg`}
      />

      <Navigation topic={Topic.COVID19} activeItem={TOP_NAV_ITEM.Topics} />

      <PageContainer>
        <PageHeading backUrl="/covid-19/">{category.name}</PageHeading>

        {category.name === "What’s going on with the pandemic?" && (
          <Container fullWidthOnMobile={true}>
            <WorldSnapshot />
          </Container>
        )}

        <Container>
          <Section>
            <Row>
              {intents.map((i) => (
                <Column key={i.alias} spanLg={6} spanMd={6} spanSm={12}>
                  <QuestionLink
                    to={getCOVIDIntentUrl(i.alias)}
                    eventCategory={EventCategory.CategoryPage}
                  >
                    {i.displayName}
                  </QuestionLink>
                </Column>
              ))}
            </Row>
          </Section>
        </Container>
      </PageContainer>
    </Layout>
  );
};

export default Covid19CategoryPage;
